import './notizie-correlate.scss';

/**
 * version    1.0
 * class      <type> (NotizieCorrelate)
 * classdesc
 */
export class NotizieCorrelate {}
